import { GridButton } from '@eforall/dashboard';


export function getButtons() {
	const buttons: GridButton[] = [];

	return buttons;
}